import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../../../form/formUtilities';

/* depositEditView */
export const createInitialForm = deposit => fromJS({
  id: normalizeInitialFormValues(deposit, ['id']),
  publicationType: normalizeInitialFormValues(deposit, ['publicationType']),
  event: normalizeInitialFormValues(deposit, ['event']),
  geologicAgeId: normalizeInitialFormValues(deposit, ['geologicAgeId']),
  ageDescription: normalizeInitialFormValues(deposit, ['ageDescription']),
  description: normalizeInitialFormValues(deposit, ['description']),
  bodyOfWater: normalizeInitialFormValues(deposit, ['bodyOfWater']),
  country: normalizeInitialFormValues(deposit, ['country']),
  yearBegin: normalizeInitialFormValues(deposit, ['yearBegin']),
  yearEnd: normalizeInitialFormValues(deposit, ['yearEnd']),
  latitude: normalizeInitialFormValues(deposit, ['latitude']),
  longitude: normalizeInitialFormValues(deposit, ['longitude']),
  locationName: normalizeInitialFormValues(deposit, ['locationName']),
  environment: normalizeInitialFormValues(deposit, ['environment']),
  publish: normalizeInitialFormValues(deposit, ['publish'], true),
  referenceId: normalizeInitialFormValues(deposit, ['referenceId']),
  tsunamiEventIds: deposit && deposit.get('tsunamiEventIds') ? deposit.get('tsunamiEventIds').map(v => `${v}`) : [],
});

export const depositEditModel = fromJS({
  name: 'depositEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  publicationType: fieldToNumber(form.get('publicationType')),
  event: fieldTrimmed(form.get('event')),
  geologicAgeId: fieldToNumber(form.get('geologicAgeId')),
  ageDescription: fieldTrimmed(form.get('ageDescription')),
  description: fieldTrimmed(form.get('description')),
  bodyOfWater: fieldTrimmed(form.get('bodyOfWater')),
  yearBegin: fieldToNumber(form.get('yearBegin')),
  yearEnd: fieldToNumber(form.get('yearEnd')),
  country: fieldTrimmed(form.get('country')),
  latitude: fieldToNumber(form.get('latitude')),
  longitude: fieldToNumber(form.get('longitude')),
  locationName: fieldTrimmed(form.get('locationName')),
  environment: fieldTrimmed(form.get('environment')),
  publish: Boolean(form.get('publish')),
  referenceId: fieldToNumber(form.get('referenceId')),
  tsunamiEventIds: fromJS(form.get('tsunamiEventIds')).map(fieldToNumber).filter(value => value != null),
});
